/**
 * Expense chart colors
 */
export const EXPENSE_COLORS = [
  '#AE855A',
  '#9D4A48',
  '#AB5249',
  '#70518B',
  '#D8AD57',
  '#C66136',
  '#E14B45',
  '#895CA9',
  '#FCB814',
  '#DC7633',
  '#DE6A67',
  '#AF79C6',
  '#FFD619',
  '#FA873D',
  '#F55142',
  '#CD6FCE',
  '#FBD985',
  '#ED9837',
  '#FF8585',
  '#D783D7',
  '#FEE9B7',
  '#FFBD5C',
  '#FF9D9D',
  '#FFABFF',
  '#FFF0E1',
  '#FFD6AC',
  '#FFD6D6',
  '#FFD5FF',
];

/**
 * Revenues charts colors
 */
export const REVENUES_COLORS = [
  '#304C8F',
  '#467C6E',
  '#437A58',
  '#719A37',
  '#5F74B0',
  '#438B83',
  '#489C6F',
  '#88B539',
  '#6B91C8',
  '#3CC1BF',
  '#9EDD94',
  '#A7CB34',
  '#0279C0',
  '#42B5B1',
  '#29C286',
  '#BDDE34',
  '#39C4FF',
  '#46C1A0',
  '#4BCF99',
  '#8DD47F',
  '#52D5FF',
  '#25D5BA',
  '#82D7AC',
  '#DAEE8E',
  '#DDFFFF',
  '#9ADEDF',
  '#A3EAC2',
  '#E3F3C6',
];

/**
 * Empty color
 */
export const EMPTY_COLOR = '#F5F5F5';
